export default "__VITE_ASSET__DAWPdO0u__"